import React from 'react';
import Head from 'next/head';
import { GetServerSideProps } from 'next';
import { SignupScreen } from 'screens/Signup/SignupScreen';
import { BootstrapLoadingWrapper } from 'components/BootstrapLoadingWrapper';
import { redirectAuthenticatedUser } from 'utils/pageUtils';
import { t } from 'translations/t';

export const getServerSideProps: GetServerSideProps = redirectAuthenticatedUser;

export default function Signup() {
  const metaTitle = 'Hevy';
  const metaDescription = t('web.metadata.desc2');

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:site_name" content={t('web.metadata.socialWorkoutTracker')} />
        <meta
          property="og:image"
          content="https://www.hevyapp.com/wp-content/uploads/hevy-social-card.jpg"
        />
        <meta property="og:image:width" content="800" />
        <meta property="og:image:height" content="400" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@hevyapp" />
        <meta name="twitter:site" content="@hevyapp" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta
          name="twitter:image"
          content="https://www.hevyapp.com/wp-content/uploads/hevy-social-card.jpg"
        />
      </Head>
      <BootstrapLoadingWrapper>
        <SignupScreen />
      </BootstrapLoadingWrapper>
    </>
  );
}
